import { Api, StringUtil } from ".";

export interface ProcessLockResult {
    success: boolean,
    message: string,
    failedKeys?: string[]
}

export class ProcessLock {
    public static async acquireLock(type: string, key: string): Promise<ProcessLockResult> {
        const response = await Api.post("process-lock", { type: type, key: key });
        return ProcessLock.createLockResult(response);
    }

    public static async acquireLocks(type: string, keys: string[]): Promise<ProcessLockResult> {
        const response = await Api.post("multi-process-lock", { type: type, keys: keys });
        return ProcessLock.createLockResults(response);
    }

    public static async releaseLock(type: string, key: string): Promise<ProcessLockResult> {
        const response = await Api.delete("process-lock", { type: type, key: key });
        return ProcessLock.createLockResult(response);
    }

    public static async releaseLocks(type: string, keys: string[]): Promise<ProcessLockResult> {
        const response = await Api.delete("multi-process-lock", { type: type, keys: keys });
        return ProcessLock.createLockResults(response);
    }

    private static createLockResult(response: any) {
        const message = response?.data[0]?.message;
        return {
            success: StringUtil.isEmptyString(message) === true,
            message: message
        }
    }

    private static createLockResults(response: any) {
        const lockResults = response?.data;
        let message = "";
        const failedKeys = [];
        lockResults?.forEach((lock: any) => {
            if (StringUtil.isEmptyString(lock.message) === false) {
                if (StringUtil.isEmptyString(message) === false) {
                    message += "\n";
                }
                message += lock.message;
                failedKeys.push(lock.id);
            }
        });
        return {
            success: StringUtil.isEmptyString(message) === true,
            message: message,
            failedKeys: failedKeys
        }
    }
}
